import posthog from 'posthog-js'

export const DEFAULT_ZOOM = 18.8
export const DEFAULT_SCALE = 0.05
// Font size in pixels of the hole number and front/side text on the print sheet
export const DEFAULT_TEXT_SIZE = 12

export function openPinvisionStore() {
  window.open('https://tosto.re/pinvision', '_blank')
}

export function openAppStoreByDevice() {
  // Detect device type
  const userAgent = navigator.userAgent || navigator.vendor || ''

  // Check if iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as Window & { MSStream?: unknown }).MSStream) {
    openAppStore()
    return
  }

  // Check if Android
  if (/android/i.test(userAgent)) {
    openPlayStore()
    return
  }

  // Default: open both stores or show options
  // For desktop/unknown devices, you could show both or default to one
  // For now, we'll default to App Store
  openAppStore()
}

export function openAppStore() {
  posthog.capture('store_button_clicked', { store: 'app_store' })
  window.open('https://apps.apple.com/app/pin-vision-golf-gps/id1514234482', '_blank')
}

export function openPlayStore() {
  posthog.capture('store_button_clicked', { store: 'play_store' })
  window.open('https://play.google.com/store/apps/details?id=it.pinvisionapp', '_blank')
}

export function openApiDocs() {
  posthog.capture('cta_clicked', { cta: 'api_docs' })
  window.open('https://docs.pinvision.app', '_blank')
}

export function scrollToId(id: string) {
  posthog.capture('cta_clicked', { cta: id })
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function convertDirectionFromDB(direction: string) {
  if (direction === 'sx') {
    return 'L'
  }
  if (direction === 'dx') {
    return 'R'
  }
  if (direction === 'ct') {
    return 'C'
  }
  return direction
}

export function convertDirectionToDB(direction: string) {
  if (direction === 'L') {
    return 'sx'
  }
  if (direction === 'R') {
    return 'dx'
  }
  if (direction === 'C') {
    return 'ct'
  }
  return direction
}

export function formatDateToYYYYMMDD(date: Date): string {
  console.log(date)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // month is 0-based
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatDate(date: string | null): Date | string {
  return date ? new Date(date).toLocaleString() : 'N/A'
}

export function formatDateOnly(date: string | null): string {
  return date ? new Date(date).toLocaleDateString() : 'N/A'
}

export function parseDate(value?: string | null): string | null {
  if (!value) {
    return null
  }
  return value.split('T')[0] // keeps YYYY-MM-DD
}

export function getStatusByDate(dateFrom?: string, dateTo?: string, status?: boolean): string {
  const now = new Date()

  if (!dateFrom || !dateTo) {
    return 'Unknown'
  }

  const from = new Date(dateFrom)
  const to = new Date(dateTo)

  if (isNaN(from.getTime()) || isNaN(to.getTime())) {
    return 'Unknown'
  }

  if (status === false) {
    return 'Inactive'
  }

  if (now < from) {
    return 'Inactive'
  }
  if (now >= from && now <= to) {
    return 'Active'
  }
  if (now > to) {
    return 'Expired'
  }

  return 'Unknown'
}

export function getStatusSeverityByDate(
  dateFrom?: string,
  dateTo?: string,
  status?: boolean,
): string {
  const statusByDate = getStatusByDate(dateFrom, dateTo, status)

  switch (statusByDate) {
    case 'Active':
      return 'success'
    case 'Inactive':
      return 'warning'
    case 'Expired':
      return 'danger'
    default:
      return 'info'
  }
}

export const getLanguageFlag = (languageCode: string): string => {
  const languageToFlagMap: Record<string, string> = {
    it: '🇮🇹',
    en: '🇬🇧',
    de: '🇩🇪',
    fr: '🇫🇷',
    es: '🇪🇸',
  }

  return languageToFlagMap[languageCode] || 'N/A'
}

/** Password policy enforced by the API (AuthAdminResetPasswordDto / AuthAdminCreateUserDto). */
export const PASSWORD_REGEX = /^(?=.*\d).{6,}$/
